import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem('jwtToken');

  if (!token) {
    console.warn("Access denied! No token found.");
    return <Navigate to="/" replace />;
  }

  try {
    const decodedToken = jwtDecode(token); // Decode the token
    const currentTime = Date.now() / 1000; // Current time in seconds

    // Check if the token is expired
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      console.warn("Token expired! Redirecting to login...");
      localStorage.removeItem('jwtToken'); // Clear the expired token
      return <Navigate to="/" replace />;
    }

    //////////////////////////////console.log("Token is valid:", decodedToken);
  } catch (err) {
    console.error("Invalid token:", err);
    return <Navigate to="/" replace />; // Redirect if token is invalid
  }

  // Render the protected component if the token is valid
  return element;
};

export default ProtectedRoute;
